export const POSITIONS_MANAGER_WIDTH = 308;
export const ICONS_TOOLBAR_WIDTH = 58;
export const PANELS_WIDTH = 240;
export const HEADER_HEIGHT = 53;
export const PINTURA_MAX_MARGIN_LEFT = 174;
export const PINTURA_MAX_MARGIN_RIGHT = 94;
export const BACKGROUND_IMAGE_DPI = 96;
export const BACKGROUND_IMAGE_W = 1000;
export const BACKGROUND_IMAGE_H = 1023;
export const AREA_MARGINS = 10;
export const PREVIEW_IMAGE_BOX = 204;
export const PREVIEW_PRODUCT_BOX = 680;
export const ORDER_DETAILS_WIDTH = 628;
export const ORDER_DETAILS_HEIGHT = 79;
export const RIGHT_SECTIONS_HEIGHT_PADDING = 17;
export const PANELS_HEIGHT_PADDING = 3;
export const STROKE_COLOR_ACTIVE = [
  0.807843137254902, 0.058823529411764705, 0.4117647058823529,
];
export const STROKE_COLOR_PASSIVE = [0.553, 0.553, 0.553, 0.3];
export const STROKE_COLOR_GREEN = [0.141, 0.631, 0.282];

export const HOME_PANEL = 'home-panel';
export const LANYARDS_PANEL = 'lanyard-panel-options';
export const IMAGE_PANEL = 'image-panel-options';
export const TEXT_PANEL = 'text-panel-options';
